import { useState } from "react";
import { Icon } from "@iconify/react";
import { NavLink } from "react-router-dom";
import "./Router.css";

const Route = () => {
	const [visible, setVisible] = useState(false);

	return (
		<div className={`toggle ${visible ? "" : "active"}`} onClick={() => setVisible(!visible)}>
			<div className="box first">
				<NavLink to="/" className="links btn btn-outline-primary btn-rounded first">
					<p>Home</p>
				</NavLink>
			</div>
			<div className="box second">
				<NavLink to="/skills" className="links btn btn-outline-warning btn-rounded second ">
					<p>Skills</p>
				</NavLink>
			</div>
			<div className="box third">
				<Icon icon="bxs:category" className="bxs-category" id="icon" />
				<NavLink to="/projects" className="links btn btn-outline-orange btn-rounded third">
					<p>Projects</p>
				</NavLink>
			</div>
			<div className="box fourth">
				<NavLink to="/certificates" className="links btn btn-outline-danger btn-rounded second ">
					<p>Certifications</p>
				</NavLink>
			</div>
			<div className="box fifth">
				<NavLink to="/contact" className="links btn btn-outline-tosca btn-rounded first">
					<p>Contact Me</p>
				</NavLink>
			</div>
		</div>
	);
};

export default Route;
